import { NgClass } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { FormGroup, FormGroupDirective, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RadioButtonModule } from 'primeng/radiobutton';
import { CommonBindingDataService } from '../../../services/common-binding-data.service';
import { AppSettings } from 'app/modules/shared/app.settings';

@Component({
  selector: 'app-mi-radio',
  templateUrl: './mi-radio.component.html',
  styleUrls: ['./mi-radio.component.scss'],
  standalone: true,
  imports: [FormsModule, ReactiveFormsModule, RadioButtonModule, NgClass]
})
export class MiRadioComponent implements OnInit {
  @Input() field: any;
  formName: FormGroup;
  @Input() attributeLabels: [];
  @Input() moduleName: string;

  excludeCode = ["vehicle_dispatch_preference"]

  constructor(private formGroupDirective: FormGroupDirective,
    public cs: CommonBindingDataService) {
    this.formName = this.formGroupDirective.control;
  }

  ngOnInit() {
    if (this.moduleName === AppSettings.ENTITY_CODE.PASS_PRIVILEGE_CONF || this.moduleName === AppSettings.ENTITY_CODE.PASSENGER || this.moduleName === AppSettings.ENTITY_CODE.LOCATION) {
      const currentValue = this.formName.controls[this.field?.isOneToMultiple ? this.field?.attributeCodeOneToMultiple : this.field.attributeCode].value;
      if (!currentValue) {
        this.defaultValuesForPrivilegeSettings();
      }
    } else {
      this.defaultValuesForPrivilegeSettings();
    }
  }

  defaultValuesForPrivilegeSettings() {
    if(this.moduleName === AppSettings.ENTITY_CODE.PASS_PRIVILEGE_CONF || this.moduleName === AppSettings.ENTITY_CODE.PASSENGER || this.moduleName === AppSettings.ENTITY_CODE.LOCATION) {
      this.formName.get(this.field.attributeCode)?.setValue(this.field.defaultValue);
    }
  }

  isSelected(labelKey: string): boolean {
    return this.formName.get(this.field.attributeCode)?.value?.key === labelKey;
  }
}
